/* Vitarights GCC — currency switcher labels only.
   Turns "United Arab Emirates Dirham" into "AED" in the Beast dropdown.
   It does NOT move the widget or touch its positioning — an earlier version
   did, and that hid it. Rewrites text nodes only. */
(function () {
  'use strict';

  var CODES = {
    'kuwaiti dinar': 'KWD', 'kuwait dinar': 'KWD',
    'saudi riyal': 'SAR', 'saudi arabian riyal': 'SAR', 'saudi rial': 'SAR',
    'united arab emirates dirham': 'AED', 'uae dirham': 'AED', 'emirati dirham': 'AED',
    'bahraini dinar': 'BHD', 'qatari riyal': 'QAR', 'qatari rial': 'QAR',
    'omani rial': 'OMR', 'omani riyal': 'OMR',
    'us dollar': 'USD', 'united states dollar': 'USD',
    'euro': 'EUR',
    'british pound': 'GBP', 'pound sterling': 'GBP', 'british pound sterling': 'GBP',
    'jordanian dinar': 'JOD', 'iraqi dinar': 'IQD', 'lebanese pound': 'LBP',
    'egyptian pound': 'EGP', 'moroccan dirham': 'MAD', 'tunisian dinar': 'TND',
    'turkish lira': 'TRY', 'indian rupee': 'INR', 'pakistani rupee': 'PKR',
    'canadian dollar': 'CAD', 'australian dollar': 'AUD', 'new zealand dollar': 'NZD',
    'swiss franc': 'CHF', 'swedish krona': 'SEK', 'norwegian krone': 'NOK',
    'danish krone': 'DKK', 'japanese yen': 'JPY', 'chinese yuan': 'CNY',
    'hong kong dollar': 'HKD', 'singapore dollar': 'SGD', 'south african rand': 'ZAR'
  };

  function norm(s) {
    return String(s).toLowerCase().replace(/[^a-z ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function relabel() {
    try {
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var nodes = [], n;
      while ((n = walker.nextNode())) nodes.push(n);
      for (var i = 0; i < nodes.length; i++) {
        var t = nodes[i], raw = (t.nodeValue || '').trim();
        if (raw.length < 4 || raw.length > 34) continue;
        var code = CODES[norm(raw)];
        if (code && raw !== code) t.nodeValue = code;
      }
    } catch (e) {}
  }

  function boot() {
    relabel();
    var tries = 0;
    var iv = setInterval(function () { relabel(); if (++tries > 40) clearInterval(iv); }, 300);
    try {
      new MutationObserver(function () { relabel(); })
        .observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    ['click', 'focusin'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(relabel, 50); }, true);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
